import React from 'react';
import ReactDom from 'react-dom';
import 'rxjs';

import RootContainer from './containers/root/root';
import { configureStore } from './redux/configure-store';
import { installUnhandled } from './utils/error-logger/error-logger';
import '@wix/design-system/styles.global.css';

installUnhandled();

const store = configureStore();
const rootElement = document.getElementById('root');

ReactDom.render(<RootContainer store={store} />, rootElement);
